export default __webpack_public_path__ + "static/media/highlight-7-new.c1501d2f.png";